export const isLocalStorageAvailable = () => {
  const testKey = '__storage_test__'

  try {
    localStorage.setItem(testKey, 'test')
    localStorage.removeItem(testKey)
    return true
  } catch (e) {
    return false
  }
}
